const usersFilters = [
  {
    targetKey: "fullName",
    placeholder: "Utilisateur",
    defaultValue: "fullName"
  },
  {
    targetKey: "email",
    placeholder: "Email",
    defaultValue: "email"
  },
  {
    targetKey: "role",
    placeholder: "Rôle",
    defaultValue: "role_label"
  },
  {
    targetKey: "clients",
    placeholder: "Client",
    defaultValue: "clients.label"
  },
  { targetKey: "lucca_legal_entity_name", placeholder: "Entreprise", defaultValue: "lucca_legal_entity_name" },
  {
    targetKey: "lucca_manager_name",
    placeholder: "Nom du manager",
    defaultValue: "lucca_manager_name"
  },
  { targetKey: "lucca_department_name", placeholder: "Nom du département", defaultValue: "lucca_department_name" },
  { targetKey: "effectif", placeholder: "effectif", defaultValue: "effectif" }
];

export default usersFilters;



// WEBPACK FOOTER //
// src/containers/admin/users/Users.utils.js